import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import TaxFlowChartSectionOne from './components/TaxFlowChartSectionOne';
import TaxFlowChartSectionTwo from './components/TaxFlowChartSectionTwo';
import TaxFlowChartSectionThree from './components/TaxFlowChartSectionThree';
import TaxFlowChartSectionFour from './components/TaxFlowChartSectionFour';
import TaxFlowChartSectionFive from './components/TaxFlowChartSectionFive';

export default class TaxFlowChart extends React.Component {
  static init(id, props) {
    ReactDOM.render(
      <TaxFlowChart {...props} />,
      document.getElementById(id),
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      section: 0,
      eligible: true,
      isSingle: true,
      validQBI: true,
      partnerInsurance: false,
    };
    this.iconSrc = `${this.props.cdnURL}/images/TaxFlowChart/alex-icon-2x.png`;
    if (props.isFemale) {
      this.iconSrc = `${this.props.cdnURL}/images/TaxFlowChart/gen-icon-2x.png`;
    }
    this.updateSection = this.updateSection.bind(this);
    this.setFilingStatus = this.setFilingStatus.bind(this);
    this.setQBI = this.setQBI.bind(this);
    this.setPartnerInsurance = this.setPartnerInsurance.bind(this);
  }

  setFilingStatus(isSingle) {
    this.updateSection(2);
    this.setState({
      isSingle,
    });
  }

  setQBI(validQBI) {
    this.updateSection(3);
    this.setState({
      validQBI,
    });
  }

  setPartnerInsurance(partnerInsurance) {
    this.updateSection(4);
    this.setState({
      partnerInsurance,
    });
  }

  updateSection(section, eligible = true) {
    this.setState({
      section,
      eligible,
    });
  }

  render() {
    return (
      <div className="container tax-flow-chart-container">
        <TaxFlowChartSectionOne
          updateSection={this.updateSection}
          section={this.state.section}
          eligible={this.state.eligible}
          iconSrc={this.iconSrc}
          cdnURL={this.props.cdnURL}
        />
        {this.state.section > 0 &&
          <TaxFlowChartSectionTwo
            setFilingStatus={this.setFilingStatus}
            section={this.state.section}
            isSingle={this.state.isSingle}
            eligible={this.state.eligible}
            iconSrc={this.iconSrc}
            cdnURL={this.props.cdnURL}
          />
        }
        {this.state.section > 1 &&
          <TaxFlowChartSectionThree
            isSingle={this.state.isSingle}
            setQBI={this.setQBI}
            validQBI={this.state.validQBI}
            section={this.state.section}
            iconSrc={this.iconSrc}
            cdnURL={this.props.cdnURL}
          />
        }
        {this.state.section > 2 && !this.state.isSingle && this.state.validQBI &&
          <TaxFlowChartSectionFour
            partnerInsurance={this.state.partnerInsurance}
            setPartnerInsurance={this.setPartnerInsurance}
            section={this.state.section}
          />
        }
        {this.state.section > 3 &&
          <TaxFlowChartSectionFive
            partnerInsurance={this.state.partnerInsurance}
            section={this.state.section}
            cdnURL={this.props.cdnURL}
          />
        }
      </div>
    );
  }
}

TaxFlowChart.propTypes = {
  isFemale: PropTypes.bool.isRequired,
  cdnURL: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src-react/TaxFlowChart/index.jsx